<template>
  <div class="main-message">
<!--    <header>-->
<!--      <h3>消息</h3>-->
<!--    </header>-->
    <main>
      <header>
        <h3>消息</h3>
        <!-- <span>/ computer management</span> -->

      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText">
            <a-input-search placeholder="通知内容" v-model="pagination.searchText" @input="searchTextChange" allow-clear
                            :loading="btnLoad" />
          </a-form-model-item>
          <a-form-model-item prop="noticeLevel">
            <a-select v-model="pagination.noticeLevel" placeholder="消息级别" style="width: 180px; " allowClear
                      :loading="btnLoad" @change="searchChange">
              <a-select-option :value="1">消息</a-select-option>
              <a-select-option :value="3">错误</a-select-option>
              <a-select-option :value="2">严重</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="noticeType">
            <a-select v-model="pagination.noticeType" placeholder="对象" style="width: 180px; " allowClear
                      :loading="btnLoad" @change="searchChange">
              <a-select-option :value="0">作业</a-select-option>
              <a-select-option :value="1">流程</a-select-option>
              <a-select-option :value="2">触发器</a-select-option>
              <a-select-option :value="3">机器人</a-select-option>
              <a-select-option :value="4">队列</a-select-option>
              <a-select-option :value="5">资源</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item  prop="orgId">
            <a-tree-select
                allowClear
                v-model='pagination.orgId'
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="选择部门"
                style="width: 200px;"
                @change="searchChange"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item prop="time">
            <a-range-picker  :value="pagination.time" v-model="pagination.time"
                             valueFormat="YYYY-MM-DD" style="width: 200px;" @change="searchChange" />
          </a-form-model-item>
          <a-form-model-item >
            <a-button  @click="resetSearch">重 置</a-button>
          </a-form-model-item>
        </a-form-model>

      </div>
      <!-- 数据表格 -->
      <a-table :columns="tableColumns" bordered :data-source="tableData" @change="handleTableChange" :pagination="queryCondition"  :scroll="{ y: 560 }">
        <template slot="noticeLevel" slot-scope="text">
          <span v-if="text === 1">
            <a-tag color="green">消息</a-tag>
          </span>
          <span v-if="text === 2">
            <a-tag color="red">严重</a-tag>
          </span>
          <span v-if="text === 3">
            <a-tag color="orange">错误</a-tag>
          </span>  
        </template>
        <template slot="noticeType" slot-scope="text" >
          <img :src="noticeTypeList[text].img" class="img-lc" alt="">
          {{ noticeTypeList[text].title}}
        </template>
        <template slot="message" slot-scope="text" >
         <span :title="text"> {{ text == 'null' ? '':text }}</span>
        </template>
      </a-table>
    </main>


  </div>
</template>
  
<script>
export default {
  data() {
    return {
      dateFormat: 'YYYY/MM/DD',
      btnLoad: false,
      tableLoad: false,
      pagination: {
        searchText: "",
        noticeType:undefined,
        noticeLevel:undefined,
        orgId:undefined,
        time: [this.$moment().subtract(6, 'days').format("YYYY-MM-DD"),this.$moment().subtract('month').format("YYYY-MM-DD")],
        pageSize: 10,
        pageNo: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      formLayout: "inline",
      queryCondition: {},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: '消息级别',
          key: 'noticeLevel',
          dataIndex: 'noticeLevel',
          scopedSlots: { customRender: "noticeLevel" },
          ellipsis: true,
        },
        {
          title: '对象',
          key: 'noticeType',
          dataIndex: 'noticeType',
          scopedSlots: { customRender: "noticeType" },
          ellipsis: true,
        },
        {
          title: '内容',
          key: 'message',
          dataIndex: 'message',
          scopedSlots: { customRender: "message" },
          ellipsis: true,
        },
        {
          title: "部门",
          ellipsis: true,
          dataIndex: "orgName",
          key: "orgName",
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          ellipsis: true,
        },

      ],
      tableData: [],
      noticeTypeList:{
        0:{
           title:"作业",
           img: require("../assets/images/Task_selected.png"),
        },
        1:{
           title:"流程",
           img: require("../assets/images/Process_message.png"),
        },
        2:{
           title:"触发器",
           img: require("../assets/images/Trigger_selected.png"),
        },
        3:{
           title:"机器人",
           img: require("../assets/images/Robot_selected.png"),
        },
        4:{
           title:"队列",
           img: require("../assets/images/Queue_message.png"),
        },
        5:{
          title:"资源",
          img: require("../assets/images/resources.png"),
        },
      },
      // 部门列表
      treeData:[],

    };
  },
  methods: {
    // 重置搜索
    resetSearch() {
      this.$refs.searchBar.resetFields()
      this.searchChange()
      this.queryCondition.current = 1
    },  

    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      // this.queryCondition.time = [this.$moment().subtract(6, 'days').format("YYYY-MM-DD"),this.$moment().subtract('month').format("YYYY-MM-DD")]
      // console.log(this.queryCondition.time);
      this.queryCondition.time = this.queryCondition.time ? this.queryCondition.time.join(',') : ''
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo = pagination.current
      this.queryCondition.current = pagination.current
      this.queryCondition.pageSize = pagination.pageSize
      this.tableAjax()
    },
    // 部门下拉框
    allorgList() {
      this.axios
          .post("/org/findOrg",'')
          .then((res) => {
            if (res.code === 200) {
              this.treeData = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
        .post("/notice/findPage", this.$qs.stringify(this.queryCondition))
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.queryCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
  },
  beforeMount() {
    this.searchChange();
    this.allorgList()
  }
};
</script>
  
<style lang="scss" scoped>
.main-message {

  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }
    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }

    i.table-action {
      cursor: pointer;
      display: inline-block;
      margin: -5px 0;
      width: 30px;
      height: 30px;
      background: url("../assets/images/Table_action.png") no-repeat center;
      border-radius: 20px;
      vertical-align: top;

      &:active {
        background-color: #d8e6ff;
      }
    }

    .ant-tag {
      border-radius: 16px;
    }
  }
}

.ant-operation-menu {
  display: flex;

  i {
    margin-top: 5px;
    font-size: 18px;
  }
}

::v-deep .version {
  .anticon {
    margin-right: 5px;
    color: #fa9635;
  }
}
::v-deep .img-lc {
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-right: 3px;
  margin-top: -2px;
}
</style>
  